import React from "react";
import ResetForm from "./ResetForm";
import { Actions } from "../../../core/modules/Actions";

const ResetQuizAttemptsForm = ({ onclickcancel = () => {}, onSuccess = () => {} }) => {
  return (
    <ResetForm
      onclickcancel={onclickcancel}
      onSuccess={onSuccess}
      title="Reset Student's Quiz Attempts"
      buttonText="Reset Quiz Attempts"
      placeholder="Enter student email address"
      onSubmitAction={Actions.quizes.resetAllAttempts}
    />
  );
};

export default ResetQuizAttemptsForm;


